import SpringConfigs from 'utils/constants/swarm/spring-configs';
import {
  getPageAliasFromUrl,
  sbRedirect
} from 'utils/generic/route-manipulation';
import { AToZData } from 'interfaces/generic';
import { GLOBALS } from './global-variables';

export const redirectToUrl = (path: string, tab: AToZData): void => {
  const lang = GLOBALS.languageConfigs;
  const langPrefix = lang.prefix;
  const isLangDefault = lang.default === 1;

  if (path.includes('https:/') || path.includes('http:/')) {
    sbRedirect(path, false, true);
  } else {
    if (tab.type && SpringConfigs.PAGE_URLS[tab.type]) {
      if (tab.category === 'esport' && tab.type === 'prematch') {
        sbRedirect(SpringConfigs.PAGE_URLS[tab.category] || '', false, true);
      } else if (
        getPageAliasFromUrl(SpringConfigs.PAGE_URLS[tab.type]) ===
        getPageAliasFromUrl(path)
      ) {
        sbRedirect(SpringConfigs.PAGE_URLS[tab.type], false, true);
      } else {
        sbRedirect(path, true, false, !isLangDefault ? langPrefix : '');
      }
    } else {
      sbRedirect(
        `${window.location.origin}${
          !isLangDefault ? `/${langPrefix}` : ''
        }/${path}`,
        false,
        true
      );
    }
  }
};
